import React from 'react';

const CommunitySection = () => {
  return (
    <div className="bg-white text-center flex-1 flex flex-col p-[40px] rounded-[20px] shadow-[0_15px_45px_rgba(0,0,0,0.2)] transition-transform duration-300 hover:-translate-y-[10px] hover:shadow-[0_20px_50px_rgba(0,0,0,0.25)]">
      <h2 className="text-texto-oscuro font-extrabold text-[2.2rem] mb-[15px]">Comunidad y Acompañamiento</h2>
      <p className="text-texto-sec flex-grow text-base leading-[1.6] mb-[30px]">
        Conecta con otros miembros, comparte experiencias y recibe apoyo especializado.
      </p>
      <ul className="list-none p-0 text-left flex flex-col mx-0 mb-[30px] gap-[15px]">
        {['Historias de beneficiarios y exbecarios.', 'Mentorías en bienestar y emprendimiento.', 'Calendario de talleres y actividades.'].map((item) => (
          <li key={item} className="relative text-base pl-[28px]">
            <span className="absolute left-0 text-icetex font-bold">✓</span>
            {item}
          </li>
        ))}
      </ul>
      <a
        href="https://web.icetex.gov.co/comunidad-icetex-landing-page"
        target="_blank"
        rel="noopener noreferrer"
        className="bg-icetex text-white border-0 uppercase font-bold cursor-pointer no-underline inline-block py-[15px] px-[30px] rounded-[50px] text-[0.9rem] tracking-[0.5px] self-center shadow-[0_4px_15px_rgba(0,63,129,0.4)] transition-all duration-300 hover:bg-texto-oscuro hover:-translate-y-[3px]"
      >
        Participa en la comunidad
      </a>
    </div>
  );
};

export default CommunitySection;
